import { DEVICE_DID_AUTH_KEY, LS_CMS_LINK_ENABLE } from "@/util/constants.ts";

function disableMouseFunctionality() {
  window.addEventListener(
    "dragover",
    (e) => {
      e.preventDefault();
    },
    false
  );
  window.addEventListener(
    "drop",
    (e) => {
      e.preventDefault();
    },
    false
  );
  document.addEventListener(
    "contextmenu",
    (e) => {
      e.preventDefault();
    },
    false
  );
}
function disableZoom() {
  // disables zoom on chrome
  document.addEventListener(
    "wheel",
    (event) => {
      const { ctrlKey } = event;
      if (ctrlKey) {
        event.preventDefault();
      }
    },
    { passive: false }
  );
  // disables zoom on safari
  document.addEventListener(
    "gesturestart",
    (event) => {
      event.preventDefault();
    },
    { passive: false }
  );
}

function getModeUrlOrLS(type, siteId) {
  const urlParams = new URLSearchParams(window.location.search);
  const modeParam =
    urlParams.get(type) === null
      ? null
      : urlParams.get(type) === "true" || urlParams.get(type) === "1";
  const lsKey = `${type}-${siteId}`;
  const lsVal = localStorage.getItem(lsKey);
  const modeLS = localStorage.getItem(lsKey) === null ? null : lsVal === "1";
  const mode = modeParam ?? modeLS ?? false;
  localStorage.setItem(lsKey, mode ? "1" : "0");
  return mode;
}

function getCategories() {
  const urlParams = new URLSearchParams(window.location.search);
  const catValue = urlParams.get("cat");
  // ?cat=name1 will be a string and ?cat=name1&cat=name2 will be an array.
  // we want to always be stored as an array
  return typeof catValue === "string" ? [catValue] : catValue;
}

function getNoTouchMode(siteId) {
  return getModeUrlOrLS("noTouch", siteId);
}

function getTouchscreenMode(siteId) {
  return getModeUrlOrLS("touchscreen", siteId);
}

function shouldForceShowCursor(siteId) {
  return getModeUrlOrLS("cursor", siteId);
}

function shouldForceInitializeUsersnap(siteId) {
  return getModeUrlOrLS("usersnap", siteId);
}

function getPreselectedFilterValues() {
  if (typeof window === "undefined") {
    return undefined;
  }

  const filters = new URLSearchParams(window.location.search).getAll("filter");
  return Object.fromEntries(
    filters.map((filter) => filter.split(":").map((item) => item.toLowerCase()))
  );
}

// On production, let's completely hide the cursor.
// Otherwise, let's show a small red dot.
function disableCursor() {
  const redDotImage =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAAXNSR0IArs4c6QAAABRJREFUGFdj/M/A8J+BgYGBEcYAACwBA/9pGIu9AAAAAElFTkSuQmCC";

  const cursorAttributeValue = import.meta.env.PROD
    ? "none"
    : `url(${redDotImage}), auto`;

  document.head.insertAdjacentHTML(
    "beforeend",
    `
    <style>
      *, *:hover, *:focus {
        cursor: ${cursorAttributeValue} !important;
      }
    </style>
    `
  );
}

let textSelectionStyleElement = null;

function toggleTextSelection(enable) {
  if (enable) {
    // enable text selection
    if (textSelectionStyleElement && textSelectionStyleElement.parentNode) {
      textSelectionStyleElement.parentNode.removeChild(
        textSelectionStyleElement
      );
      textSelectionStyleElement = null;
    }
  } else if (!textSelectionStyleElement) {
    textSelectionStyleElement = document.createElement("style");
    textSelectionStyleElement.innerHTML = `
        *, *::before, *::after {
          user-select: none !important;
          -webkit-user-select: none !important;  /* Chrome, Safari */
          -ms-user-select: none !important;      /* IE 10+ */
          -moz-user-select: none !important;     /* Firefox */
        }
      `;
    document.head.appendChild(textSelectionStyleElement);
  }
}
function setDeviceDidAuth() {
  localStorage.setItem(DEVICE_DID_AUTH_KEY, true);
}

function getDeviceDidAuth() {
  return localStorage.getItem(DEVICE_DID_AUTH_KEY) ?? false;
}

async function deviceHasCamera() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: false, video: true });

    const atLeastOneDeviceIsCameraWithId = (
      await navigator.mediaDevices.enumerateDevices()
    )?.some((device) => device.kind === "videoinput" && device.deviceId !== "");

    return atLeastOneDeviceIsCameraWithId;
  } catch (e) {
    console.error("device.js - deviceHasCamera error", e);
    return false;
  }
}

function setCmsLinkEnabled(enabled) {
  localStorage.setItem(LS_CMS_LINK_ENABLE, enabled);
}

function getCmsLinkEnabled() {
  return localStorage.getItem(LS_CMS_LINK_ENABLE) === "true";
}

/*
This makes it so that if you drag a file onto the app and it misses the file
upload window it is ignored.
 */
function addDisableFileDrop() {
  document.addEventListener("dragover", (event) => {
    event.preventDefault();
  });

  document.addEventListener("drop", (event) => {
    event.preventDefault();
  });
}

function destroyDisableFileDrop() {
  document.removeEventListener("dragover", (event) => {
    event.preventDefault();
  });

  document.removeEventListener("drop", (event) => {
    event.preventDefault();
  });
}

function setMassiveScreen(isMassiveScreen) {
  document.documentElement.classList.toggle("massive-screen", isMassiveScreen);
}

export {
  getCategories,
  getTouchscreenMode,
  getNoTouchMode,
  shouldForceShowCursor,
  shouldForceInitializeUsersnap,
  disableZoom,
  disableCursor,
  disableMouseFunctionality,
  toggleTextSelection,
  getPreselectedFilterValues,
  setDeviceDidAuth,
  getDeviceDidAuth,
  deviceHasCamera,
  setCmsLinkEnabled,
  getCmsLinkEnabled,
  addDisableFileDrop,
  destroyDisableFileDrop,
  setMassiveScreen,
};
